// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templateAdd_input {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  margin-left: -14%;
}

._curspointer {
  cursor: pointer;
}

.templatelist_feild {
  width: 100%;
  position: relative;
  top: -21%;
}

.template_Input {
  box-shadow: 0 0px 3px rgba(0, 0, 0, 0.25) !important;
  overflow-x: hidden;
  padding-right: 0;
}

.mapped_input {
  box-shadow: 0 0px 3px rgba(0, 0, 0, 0.25) !important;
  overflow-x: hidden;
  padding-right: 0;
}

.template-editor-container,
.mapped-editor-container {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  position: relative;
}

::ng-deep .template-editor-container .editor-container,
::ng-deep .mapped-editor-container .editor-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor,
::ng-deep .mapped-editor-container .editor-container .monaco-editor {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor .overflow-guard,
::ng-deep .mapped-editor-container .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
  max-width: 100% !important;
  overflow: visible !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable,
::ng-deep .mapped-editor-container .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  max-width: 100% !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor .minimap,
::ng-deep .mapped-editor-container .editor-container .monaco-editor .minimap {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor .minimap-slider,
::ng-deep .mapped-editor-container .editor-container .monaco-editor .minimap-slider {
  display: block !important;
  visibility: visible !important;
}
::ng-deep .template-editor-container .editor-container .monaco-editor .minimap canvas,
::ng-deep .mapped-editor-container .editor-container .monaco-editor .minimap canvas {
  display: block !important;
  visibility: visible !important;
}

.template_field {
  padding-left: 23px;
}

.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.textColor {
  color: green;
}

.mat-tree-node {
  min-height: 1px;
  align-items: flex-start;
}

.mat-icon-button {
  height: 1px;
  width: 20px;
}

.mat-icon-rtl-mirror {
  vertical-align: top;
}

.accession_field {
  height: 28px !important;
  margin-left: 3%;
  padding-left: 2%;
  font-size: 12px !important;
}

.accession_field::placeholder {
  font-size: 12px !important;
}

.field_droping {
  width: 100%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -3px;
  background-color: rgb(255, 255, 255);
  left: -5px;
  height: 32px;
}

::ng-deep .field_droping .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_droping .mat-form-field-flex {
  padding: 0 !important;
}

.mod_header {
  padding-inline: 1%;
  background-color: #17a0b4 !important;
  padding-block: 5px;
  font-size: 12px !important;
  color: white;
}

.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDown .mat-select-trigger {
  min-width: 10vw;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.selection_label .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.path_class {
  width: 100%;
}

#pushMessage .modal-dialog {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 50%;
}

.form-control-cus {
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.search_btn_agent {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
  line-height: 0 !important;
}

::ng-deep.template-modal-add .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.template-modal-add {
  top: 16% !important;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.parent_card {
  background-color: #f2f2f2;
  font-size: 12px;
}

.agent_feild {
  float: left;
  width: 100%;
}

.agent_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.agent_type {
  width: 100%;
  height: 30px;
  position: relative;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.agent_name_text {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

.active_mode {
  color: #07a36e;
}

.testing_mode {
  color: #f2f2f2;
}

::ng-deep.mat-form-field .mat-form-field-wrapper {
  padding-bottom: 1%;
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

.agent_title {
  color: #0c0c0c;
  text-align: initial;
  font-size: 12px !important;
  font-weight: 700;
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

.agent_text {
  color: black;
  display: inline-block;
  top: 7px;
}

.copy_icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 18px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

::ng-deep.agent_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
}

.selectpipeline {
  width: 95%;
}

.notselectedpipeline {
  width: 82%;
}

.autocomplete-container {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  overflow: visible !important;
  height: 34px !important;
  border-radius: 5px !important;
}

.conversion-type-input::placeholder {
  color: #222;
  opacity: 1;
}

.conversion-type-wrapper {
  position: relative;
}

.conversion-type-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #333;
  font-size: 22px;
  line-height: 1;
}

.font_size_template {
  font-size: 12px !important;
}

.template_list_font {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.addbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/template/template.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,uBCES;EDDT,0BCFO;EDGP,oDAAA;EACA,iBAAA;AAAJ;;AAGI;EACI,eAAA;AAAR;;AAEI;EACQ,WAAA;EACA,kBAAA;EACA,SAAA;AACZ;;AACI;EACE,oDAAA;EACA,kBAAA;EACA,gBAAA;AAEN;;AAAI;EACE,oDAAA;EACA,kBAAA;EACA,gBAAA;AAGN;;AACI;;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEN;;AAIM;;EACE,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;AAAR;AAEQ;;EACE,sBAAA;EACA,0BAAA;AACV;AACU;;EACE,sBAAA;EACA,0BAAA;EAEA,4BAAA;AACZ;AACY;;EAEE,0BAAA;AACd;AAIU;;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;AADZ;AAKU;;EACE,yBAAA;EACA,8BAAA;AAFZ;AAMU;;EACE,yBAAA;EACA,8BAAA;AAHZ;;AAQI;EACE,kBAAA;AALN;;AAYA;EACE,aAAA;AATF;;AAYA;;EAEE,aAAA;EACA,gBAAA;EACA,qBAAA;AATF;;AAWA;EACE,YAAA;AARF;;AAUA;EACE,eAAA;EACA,uBAAA;AAPF;;AASA;EACE,WAAA;EACA,WAAA;AANF;;AAUA;EACE,mBAAA;AAPF;;AAuCA;EACE,uBCpJU;EDqJV,eAAA;EACA,gBAAA;EACA,0BCzJS;ADqHX;;AAsCA;EACE,0BC5JS;ADyHX;;AAqCA;EACE,WAAA;EACE,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAlCJ;;AAoCC;EACC,4BAAA;AAjCF;;AAmCA;EACE,qBAAA;AAhCF;;AAoCA;EACE,kBAAA;EACA,oCCpLU;EDqLV,kBAAA;EACA,0BCrLS;EDsLT,YAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAjCF;;AAmCA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAhCF;;AAkCA;EACE,WAAA;EACA,UAAA;AA/BF;;AAiCA;EACE,oBAAA;AA9BF;;AAgCA;EACE,eAAA;AA7BF;;AA+BA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA9BF;;AAgCA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AA7BF;;AA+BA;EACE,WAAA;EACA,UAAA;AA5BF;;AA8BA;EACE,6BAAA;EACA,mBAAA;AA3BF;;AA6BA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AA1BF;;AA4BA;EACE,WAAA;EACA,UAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA2BA;EACI,WAAA;AAxBJ;;AA4BA;EACE,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,2CAAA;EACA,UAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;AAzBF;;AA2BA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAxBF;;AA2BA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAxBF;;AA0BA;EACE,mBAAA;AAvBF;;AA0BA;EACE,8BAAA;AAvBF;;AAyBA;EACE,8BAAA;AAtBF;;AA2BA;EACI,yBAAA;EAA0B,eAAA;AAvB9B;;AAyBI;EACI,WAAA;EACA,WAAA;AAtBR;;AAyBM;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAtBR;;AAwBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AArBR;;AAwBM;EACE,sBAAA;AArBR;;AAwBM;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AArBR;;AAwBM;EACE,8BAAA;AArBR;;AAuBM;EACE,8BAAA;AApBR;;AAsBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAnBR;;AAsBM;EACE,WAAA;AAnBR;;AAsBM;EACE,0BAAA;AAnBR;;AAqBM;EACE,cAAA;AAlBR;;AAoBM;EACE,cAAA;AAjBR;;AAmBM;EACE,kBAAA;AAhBR;;AAkBM;EACE,sBAAA;AAfR;;AAiBM;EACE,yBAAA;EACA,eAAA;AAdR;;AAiBI;EACE,cAAA;EAAe,mBAAA;EAAmB,0BCrX7B;EDqXiD,gBAAA;AAX5D;;AAcI;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAXN;;AAcE;EACE,iDAAA;AAXJ;;AAaE;EACE,YAAA;EACE,qBAAA;EACA,QAAA;AAVN;;AAYE;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AATJ;;AAWE;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;AARJ;;AAWE;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AARJ;;AAUE;EACE,WAAA;AAPJ;;AAUE;EACE,0BAAA;AAPJ;;AASE;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AANJ;;AAQE;EACE,oCC7aQ;ED8aR,0BC7aO;ED8aP,YAAA;EACA,uBC7aQ;ED8aR,iBAAA;EACA,SAAA;EACA,OAAA;AALJ;;AAOE;EACE,UAAA;AAJJ;;AAME;EACE,UAAA;AAHJ;;AAKE;EACE,oDAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;AAFJ;;AAKA;EACE,WAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAcA;EACE,0BCheS;ADqdX;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAZF;;AAcA;EACE,oCC/eU;EDgfV,0BC/eS;EDgfT,YAAA;EACA,uBC/eU;EDgfV,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAXF","sourcesContent":["@import '../../variables.scss';\r\n.templateAdd_input{\r\n    height:$inputHeight;\r\n    font-size:$fontsize;\r\n    box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    margin-left: -14%;\r\n    }\r\n\r\n    ._curspointer{\r\n        cursor: pointer;\r\n      }\r\n    .templatelist_feild{\r\n            width: 100%;\r\n            position: relative;\r\n            top:-21%;\r\n    }\r\n    .template_Input{\r\n      box-shadow: 0 0px 3px rgb(0 0 0 / 25%) !important;\r\n      overflow-x: hidden;\r\n      padding-right: 0;\r\n    }\r\n    .mapped_input{\r\n      box-shadow: 0 0px 3px rgb(0 0 0 / 25%) !important;\r\n      overflow-x: hidden;\r\n      padding-right: 0;\r\n    }\r\n    \r\n    // Monaco editor container styles to prevent overflow while allowing minimap\r\n    .template-editor-container,\r\n    .mapped-editor-container {\r\n      width: 100%;\r\n      max-width: 100%;\r\n      overflow-x: hidden;\r\n      overflow-y: visible;\r\n      position: relative;\r\n    }\r\n    \r\n    // Ensure Monaco editors stay within their containers but allow minimap\r\n    ::ng-deep .template-editor-container,\r\n    ::ng-deep .mapped-editor-container {\r\n      .editor-container {\r\n        width: 100% !important;\r\n        max-width: 100% !important;\r\n        overflow-x: hidden !important;\r\n        overflow-y: visible !important;\r\n        \r\n        .monaco-editor {\r\n          width: 100% !important;\r\n          max-width: 100% !important;\r\n          \r\n          .overflow-guard {\r\n            width: 100% !important;\r\n            max-width: 100% !important;\r\n            // Allow minimap to be visible\r\n            overflow: visible !important;\r\n            \r\n            .monaco-scrollable-element.editor-scrollable {\r\n              // Don't force width to 100% - allow minimap space\r\n              max-width: 100% !important;\r\n            }\r\n          }\r\n          \r\n          // Set minimap width to 70px and ensure it's always visible\r\n          .minimap {\r\n            width: 70px !important;\r\n            min-width: 70px !important;\r\n            max-width: 70px !important;\r\n            display: block !important;\r\n            visibility: visible !important;\r\n            opacity: 1 !important;\r\n          }\r\n          \r\n          // Ensure minimap slider is visible\r\n          .minimap-slider {\r\n            display: block !important;\r\n            visibility: visible !important;\r\n          }\r\n          \r\n          // Ensure minimap canvas is visible\r\n          .minimap canvas {\r\n            display: block !important;\r\n            visibility: visible !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .template_field{\r\n      padding-left: 23px;\r\n    }\r\n\r\n\r\n    @import \"../../variables.scss\";\r\n\r\n\r\n.example-tree-invisible {\r\n  display: none;\r\n}\r\n\r\n.example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n.textColor{\r\n  color: green;;\r\n}\r\n.mat-tree-node {\r\n  min-height: 1px;\r\n  align-items: flex-start;\r\n}\r\n.mat-icon-button{\r\n  height:1px;\r\n  width: 20px;\r\n}\r\n\r\n\r\n.mat-icon-rtl-mirror{\r\n  vertical-align: top;\r\n}\r\n// ::ng-deep.autocomplete-container {\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   position: relative;\r\n//   overflow: visible;\r\n//   height: 40px;\r\n//   border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input{\r\n//   border-radius: 5px !important;\r\n//   padding-right: 12% !important;\r\n// }\r\n\r\n// .autocomplete-container {\r\n//   border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i{\r\n//   font-weight: 600 !important;\r\n// }\r\n\r\n\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n// height: 35px !important;\r\n// .input-container input{\r\n//   height: 35px !important;\r\n// }\r\n// }\r\n\r\n\r\n.accession_field{\r\n  height: $btnHeight;\r\n  margin-left: 3%;\r\n  padding-left: 2%;\r\n  font-size:$fontsize;\r\n}\r\n.accession_field::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.field_droping{\r\n  width: 100%;\r\n    margin-left: 4%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -3px;\r\n    background-color: rgb(255, 255, 255);\r\n    left: -5px;\r\n    height: 32px;\r\n}\r\n ::ng-deep .field_droping .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_droping .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n.mod_header{\r\n  padding-inline: 1%;\r\n  background-color:$btn-color;\r\n  padding-block: 5px;\r\n  font-size: $fontsize;\r\n  color:white;\r\n}\r\n\r\n.Template_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Template_dropDown  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.selection_label  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n::ng-deep.path_class{\r\n    width: 100%;\r\n    // margin-top: 1%;\r\n}\r\n\r\n#pushMessage .modal-dialog{\r\n  position: absolute!important;\r\n  top: 50%!important;\r\n  left: 50%!important;\r\n  transform: translate(-50%, -50%)!important;\r\n  width:50%;\r\n}\r\n\r\n.form-control-cus {\r\n  display: block;\r\n  width: 100%;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #495057;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n.search_btn_agent {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n  line-height: 0 !important;\r\n}\r\n\r\n::ng-deep.template-modal-add .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.template-modal-add{\r\n  top: 16%!important;\r\n}\r\n\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n\r\n\r\n\r\n.parent_card{\r\n    background-color:#f2f2f2; font-size: 12px;\r\n    }\r\n    .agent_feild {\r\n        float: left;\r\n        width: 100%;\r\n      }\r\n\r\n      .agent_type_feild {\r\n        width: 100%;\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n        border-radius: 5px;\r\n        padding-inline: 1%;\r\n        top: -6px;\r\n      }\r\n      .agent_type {\r\n        width: 100%;\r\n        height: 30px;\r\n        position: relative;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n        height: 0px !important;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n        top: 0;\r\n        height: 0px !important;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .active_card {\r\n        border-left: 4px solid #07a36e;\r\n      }\r\n      .failed_card {\r\n        border-left: 4px solid #da606c;\r\n      }\r\n      .agent_name_text{\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        max-width: 90% !important;\r\n        display: inline-block;\r\n      }\r\n\r\n      .agent_form_field{\r\n        width: 100%;\r\n\r\n      }\r\n      .agent_form_field input{\r\n        font-size: 12px!important;\r\n      }\r\n      .active_mode{\r\n        color: #07a36e;\r\n      }\r\n      .testing_mode{\r\n        color:#f2f2f2;\r\n      }\r\n      ::ng-deep.mat-form-field .mat-form-field-wrapper{\r\n        padding-bottom: 1%;\r\n      }\r\n      .configtable td{\r\n        padding: 1%!important;\r\n      }\r\n      .configtable tr:hover {\r\n        background-color: #f3eded;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .agent_title{\r\n      color: #0c0c0c;text-align:initial;font-size:$fontsize;font-weight: 700;\r\n    }\r\n\r\n    .text-ellipsis{\r\n      max-width: 83%;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n  }\r\n\r\n  .active_table{\r\n    background-color: #17a2b83b;\r\n  }\r\n  .agent_text{\r\n    color: black;\r\n      display: inline-block;\r\n      top: 7px;\r\n  }\r\n  .copy_icon{\r\n    background-repeat: no-repeat;\r\n    display: inline-block;\r\n    fill: currentColor;\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 18px;\r\n    position: relative;\r\n    top: 8%;\r\n    left: 2%;\r\n    cursor: pointer;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {\r\n    display: block;\r\n    position: relative !important;\r\n    top: 7px !important;\r\n  }\r\n\r\n  ::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n    transform: translateY(-1.59375em) scale(.75);\r\n    width: 133.33333%;\r\n    position: relative;\r\n    top: 13px !important;\r\n  }\r\n  .agent_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .agent_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-infix{\r\n    padding: 0%!important;\r\n    padding-bottom: 7px!important;\r\n    padding-top: 2px!important;\r\n  }\r\n  .addconfigbtn{\r\n    background-color:$btn-color;\r\n    font-size: $fontsize;\r\n    color:white ;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n  }\r\n  .selectpipeline{\r\n    width:95%;\r\n  }\r\n  .notselectedpipeline{\r\n    width:82%;\r\n  }\r\n  .autocomplete-container {\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    position: relative !important;\r\n    overflow: visible !important;\r\n    height: 34px !important;\r\n    border-radius: 5px !important;\r\n}\r\n\r\n.conversion-type-input::placeholder {\r\n  color: #222;\r\n  opacity: 1;\r\n}\r\n\r\n.conversion-type-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.conversion-type-clear {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  color: #333;\r\n  font-size: 22px;\r\n  line-height: 1;\r\n}\r\n\r\n// ::ng-deep.mat-slide-toggle.mat-checked .mat-slide-toggle-bar\r\n// {\r\n// background-color: rgba(0,0,0,.38)!important;\r\n// }\r\n// ::ng-deep.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb\r\n// {\r\n//   background-color: #fafafa!important;\r\n// }\r\n\r\n.font_size_template {\r\n  font-size: $fontsize;\r\n}\r\n\r\n\r\n.template_list_font{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n.addbtn{\r\n  background-color:$btn-color;\r\n  font-size: $fontsize;\r\n  color:white ;\r\n  height: $btnHeight;\r\n  line-height: 20px;\r\n  right: 1%;\r\n  top: 0%;\r\n  cursor: pointer;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
